import { Expose } from "class-transformer";

export class CreateProjectHasUserDto {
  @Expose()
  projectId: string;

  @Expose()
  userId: string;
}
